module.exports = __webpack_public_path__ + "img/288w.2f64da4.jpg";